import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=0d1605ef&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=0d1605ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1605ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d1605ef')) {
      api.createRecord('0d1605ef', component.options)
    } else {
      api.reload('0d1605ef', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=0d1605ef&scoped=true&", function () {
      api.rerender('0d1605ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2czKtSdNPDJ0z/JS/comp/PopupBox.vue"
export default component.exports